import { Button, Checkbox, DatePicker, Form, Input, Select, Space } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import EmptyContent from '../../../components/EmptyContent'
import { DATE_FORMAT_LIST, ISO_DATE_FORMAT } from '../../../constants'
import utils from '../../../utils'

const { RangePicker } = DatePicker
const { Option } = Select

const AdvanceFilterBlock = props => {
  const { authorityStore, handleChangeParams, onClose } = props
  const { authorityIssuedsList } = authorityStore
  const location = useLocation()
  const queryStringParse = queryString.parse(location.search)

  const [form] = Form.useForm()

  useEffect(() => {
    form.setFieldsValue({
      title: queryStringParse.title || undefined,
      document_number: queryStringParse.document_number || undefined,
      incoming_number: queryStringParse.incoming_number || undefined,
      incoming_date: queryStringParse.from_incoming_date && queryStringParse.to_incoming_date
        ? [moment(queryStringParse.from_incoming_date), moment(queryStringParse.to_incoming_date)]
        : undefined,
      date_issued: queryStringParse.from_date_issued && queryStringParse.to_date_issued
        ? [moment(queryStringParse.from_date_issued), moment(queryStringParse.to_date_issued)]
        : undefined,
      signer: queryStringParse.signer || undefined,
      authority_name: queryStringParse.authority_name ? [queryStringParse.authority_name] : [],
      only_unread: queryStringParse.only_unread === 'true'
    })
  }, [queryStringParse, form])

  const onFinish = values => {
    handleChangeParams({
      title: queryStringParse.title || null,
      document_number: values.document_number?.trim() || null,
      incoming_number: values.incoming_number?.trim() || null,
      from_incoming_date: values.incoming_date ? moment(values.incoming_date[0]).format(ISO_DATE_FORMAT) : null,
      to_incoming_date: values.incoming_date ? moment(values.incoming_date[1]).format(ISO_DATE_FORMAT) : null,
      from_date_issued: values.date_issued ? moment(values.date_issued[0]).format(ISO_DATE_FORMAT) : null,
      to_date_issued: values.date_issued ? moment(values.date_issued[1]).format(ISO_DATE_FORMAT) : null,
      signer: values.signer?.trim() || null,
      authority_name: values.authority_name?.length > 0 ? values.authority_name[values.authority_name.length - 1] : null,
      only_unread: values.only_unread ? true : false
    })
    if (onClose) onClose()
  }

  const filterSelectOption = (input, option) => {
    return utils.nonAccentVietnamese(option.name).indexOf(utils.nonAccentVietnamese(input)) >= 0
  }

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      style={{ width: '100%', maxHeight: '60vh', overflowY: 'auto', paddingRight: 8 }}
      className="advance-filter-form"
    >
      <style>{`
        .advance-filter-form .ant-form-item {
          margin-bottom: 16px;
        }
        .advance-filter-form .ant-form-item-label > label {
          color: #333;
        }
        .advance-filter-form .ant-input,
        .advance-filter-form .ant-input-affix-wrapper,
        .advance-filter-form .ant-picker,
        .advance-filter-form .ant-select-selector {
          border-radius: 8px !important;
        }
      `}</style>
      
      <Form.Item label="Số hiệu" name="document_number">
        <Input placeholder="Số hiệu" allowClear />
      </Form.Item>

      <Form.Item label="Số đến" name="incoming_number">
        <Input placeholder="Số đến" allowClear />
      </Form.Item>

      <Form.Item label="Ngày đến" name="incoming_date">
        <RangePicker
          placeholder={['Từ ngày', 'Đến ngày']}
          format={DATE_FORMAT_LIST}
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item label="Ngày ban hành" name="date_issued">
        <RangePicker
          placeholder={['Từ ngày', 'Đến ngày']}
          format={DATE_FORMAT_LIST}
          style={{ width: '100%' }}
        />
      </Form.Item>

      <Form.Item label="Người ký" name="signer">
        <Input placeholder="Người ký" allowClear />
      </Form.Item>

      <Form.Item label="Cơ quan ban hành" name="authority_name">
        <Select
          mode="tags"
          filterOption={filterSelectOption}
          allowClear
          showSearch
          showArrow
          optionFilterProp={'name'}
          notFoundContent={<EmptyContent />}
          placeholder="Chọn hoặc nhập cơ quan ban hành"
          onChange={(val) => form.setFieldsValue({ authority_name: val.length > 0 ? [val[val.length - 1]] : [] })}
        >
          {authorityIssuedsList.map(authorityIssued => (
            <Option name={authorityIssued.name} value={authorityIssued.name} key={authorityIssued.id}>
              {authorityIssued.name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item label="Trạng thái văn bản" name="only_unread" valuePropName="checked">
        <Checkbox>Hiển thị văn bản chưa đọc</Checkbox>
      </Form.Item>

      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, marginTop: 24, marginBottom: 8 }}>
        <Button onClick={onClose} style={{ borderRadius: 8, flex: 1, height: 40 }}>
          Huỷ
        </Button>
        <Button type="primary" htmlType="submit" style={{ borderRadius: 8, flex: 1, height: 40 }}>
          Áp dụng
        </Button>
      </div>
    </Form>
  )
}

export default inject('authorityStore')(observer(AdvanceFilterBlock))
